import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-distribution-share",
  "use": "icon-distribution-share-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-distribution-share\"><path d=\"M512 64a42.6496 42.6496 0 1 1 0 85.3504A362.6496 362.6496 0 1 0 874.6496 512a42.6496 42.6496 0 0 1 85.3504 0A448 448 0 1 1 512 64z m218.7264 4.1472l2.9184 1.536 184.9856 106.7008c17.7152 10.24 25.6 31.5392 19.0976 50.6368l-1.3312 3.328-83.456 192a42.6496 42.6496 0 0 1-79.4624-30.9248l1.2288-3.072 41.984-96.6144c-167.5776 4.864-258.7648 91.136-283.7504 268.8512a42.6496 42.6496 0 0 1-84.48-11.8784c30.0544-213.8624 150.7328-331.008 352.4608-341.7088l-109.8752-63.3856a42.6496 42.6496 0 0 1-17.2032-55.296l1.536-2.9696a42.6496 42.6496 0 0 1 55.296-17.2032z\" p-id=\"5549\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/distribution-share.svg
// module id = e8zW
// module chunks = 57